import MeetingORM from "@/store/orm-axios/models/Meeting";
import MandateORM from "@/store/orm-axios/models/Mandate";
import ContactORM from "@/store/orm-axios/models/Contact";

export default {
  methods: {
    /** OPTIMIZATION: Clear all caches when data changes */
    clearMeetingPresenceSelectOptionsCache() {
      this._boDataCache = null;
      this._boDataCacheSize = null;
      this._boDataByIdCache = null;
      this._boDataByIdCacheSize = null;
      this._contactDataCache = null;
      this._contactDataCacheSize = null;
      this._contactDataByIdCache = null;
      this._contactDataByIdCacheSize = null;
    },

    /** get BOs + contacts that did NOT show up or are represented */
    getBOsCsNotShowUpNotIntendToOrRepresentedGroupedOpts() {
      var BOsThatDidNotShowUpOrRepresentedOptions = this.getBOsNotShowedUpOrRepresentedOpts();
      var CsNotShowUpNotIntendToOptions = this.getCsNotShowUpNotIntendToOpts();

      return [
        {
          group: "Copropriétaire",
          items: BOsThatDidNotShowUpOrRepresentedOptions,
        },
        {
          group: "Contacts",
          items: CsNotShowUpNotIntendToOptions,
        },
      ];
    },
    /** get BOs + contacts that did NOT show up or are NOT represented */
    getBOsCsNotShowUpNotIntendToOrNotRepresentedGroupedOpts() {
      var BOsThatDidNotShowUpOrNotRepresentedOptions = this.getBOsNotShowedUpOrNotRepresentedOpts();
      var CsNotShowUpNotIntendToOptions = this.getCsNotShowUpNotIntendToOpts();

      return [
        {
          group: "Copropriétaire",
          items: BOsThatDidNotShowUpOrNotRepresentedOptions,
        },
        {
          group: "Contacts",
          items: CsNotShowUpNotIntendToOptions,
        },
      ];
    },
    getBOsNotShowedUpOrRepresentedOpts() {
      var BOsThatDidNotShowUp = this.getBOsNotShowedUpOpts();
      var BOsThatDidShowUpButRepresented = this.getBOsShowedUpButRepresentedOpts();

      return [].concat(BOsThatDidNotShowUp, BOsThatDidShowUpButRepresented);
    },
    getBOsNotShowedUpOrNotRepresentedOpts() {
      var BOsThatDidNotShowUp = this.getBOsNotShowedUpOpts();
      var BOsThatDidShowUpNotRepresented = this.getBOsShowedUpNotRepresentedOpts();

      return [].concat(BOsThatDidNotShowUp, BOsThatDidShowUpNotRepresented);
    },
    getBOsNotShowedUpOpts() {
      var mandatesThatDidNotShowUp = this.getMandatesThatDidNotShowUp();
      return this.getBOsFromBuildingOwnersData(mandatesThatDidNotShowUp);
    },
    getBOsShowedUpButRepresentedOpts() {
      var mandatesThatDidShowUpButRepresented = this.getMandatesThatDidShowUpButRepresented();
      return this.getBOsFromBuildingOwnersData(mandatesThatDidShowUpButRepresented);
    },
    getBOsShowedUpNotRepresentedOpts() {
      var mandatesThatDidShowUpButRepresented = this.getMandatesThatDidShowUpNotRepresented();
      return this.getBOsFromBuildingOwnersData(mandatesThatDidShowUpButRepresented);
    },
    getCsNotShowUpNotIntendToOpts() {
      const {
        csNotShowUpNotIntendTo,
        contactsThatShowedUpOrIntendToIds,
      } = this.getCsNotShowUpNotIntendTo();
      return this.getContactsFromContactsData(
        csNotShowUpNotIntendTo,
        contactsThatShowedUpOrIntendToIds
      );
    },

    /** get BOs + contacts that did show up and are NOT absent (ignore current representant) */
    getBOsCsShowedUpNotAbsentGroupedOpts(ignoreCurrentMandate) {
      var mandatesThatDidShowUpAndNotAbsent = this.getMandatesThatDidShowUpAndNotAbsent();

      var BOsThatDidShowUpAndNotAbsentOptions = this.getBOsShowedUpNotAbsentOpts(
        mandatesThatDidShowUpAndNotAbsent,
        ignoreCurrentMandate
      );
      var contactsThatDidShowUpAndNotAbsentOptions = this.getCsShowedUpNotAbsentOpts(
        mandatesThatDidShowUpAndNotAbsent,
        ignoreCurrentMandate
      );

      return [
        {
          group: "Copropriétaire",
          items: BOsThatDidShowUpAndNotAbsentOptions,
        },
        {
          group: "Contacts",
          items: contactsThatDidShowUpAndNotAbsentOptions,
        },
      ];
    },
    getBOsShowedUpNotAbsentOpts(mandatesThatDidShowUpAndNotAbsent, ignoreCurrentMandate) {
      var buildingOwnersOptions = [];

      const groupedMandates = this.$_.groupBy(mandatesThatDidShowUpAndNotAbsent, item => {
        if (item.representant_owner_id) return item.representant_owner_id;
      });

      // OPTIMIZATION: Create lookup map for BuildingOwnersData
      if (
        !this._boDataByIdCache ||
        this._boDataByIdCacheSize !== this.meetingDetails.BuildingOwnersData.length
      ) {
        this._boDataByIdCache = new Map(
          this.meetingDetails.BuildingOwnersData.map(bo => [bo.id, bo])
        );
        this._boDataByIdCacheSize = this.meetingDetails.BuildingOwnersData.length;
      }

      for (let [representantOwnerId, groupOfMandates] of Object.entries(groupedMandates)) {
        var buildingOwnerData = this._boDataByIdCache.get(parseInt(representantOwnerId));
        if (
          buildingOwnerData &&
          representantOwnerId !== ignoreCurrentMandate.representant_owner_id // ignore current representant
        ) {
          var buildingOwnerDataModified = JSON.parse(JSON.stringify(buildingOwnerData));

          const {
            totalMandateVotes,
            totalMandateTantiemesChargeGenerale,
            reducedMandateTantiemesChargeGenerale,
          } = this.getVotingLimitRulesInfoForAGroupOfMandates(groupOfMandates);

          const {
            participantHasDummyVideoPresenceStatus,
            participantPresenceType,
          } = this.getPresenceInfoForAGroupOfMandates(groupOfMandates);

          // !!!: modified values (sum)
          buildingOwnerDataModified = Object.assign(buildingOwnerDataModified, {
            isParticipant: true,
            presenceType: participantPresenceType,
            hasDummyVideoPresenceStatus: participantHasDummyVideoPresenceStatus,
            totalMandateVotes: totalMandateVotes,
            totalMandateTantiemesChargeGenerale: totalMandateTantiemesChargeGenerale,
            reducedMandateTantiemesChargeGenerale: reducedMandateTantiemesChargeGenerale, // ..
          });

          buildingOwnersOptions.push(buildingOwnerDataModified);
        }
      }

      return buildingOwnersOptions;
    },
    getCsShowedUpNotAbsentOpts(mandatesThatDidShowUpAndNotAbsent, ignoreCurrentMandate) {
      var contactsOptions = [];

      const groupedMandates = this.$_.groupBy(mandatesThatDidShowUpAndNotAbsent, item => {
        if (item.representant_contact_id) return item.representant_contact_id;
      });

      // OPTIMIZATION: Create lookup map for ContactsData
      if (
        !this._contactDataByIdCache ||
        this._contactDataByIdCacheSize !== this.meetingDetails.ContactsData.length
      ) {
        this._contactDataByIdCache = new Map(this.meetingDetails.ContactsData.map(c => [c.id, c]));
        this._contactDataByIdCacheSize = this.meetingDetails.ContactsData.length;
      }

      for (let [representantContactId, groupOfMandates] of Object.entries(groupedMandates)) {
        var contactData = this._contactDataByIdCache.get(parseInt(representantContactId));
        if (
          contactData &&
          representantContactId !== ignoreCurrentMandate.representant_contact_id // ignore current representant
        ) {
          var contactDataModified = JSON.parse(JSON.stringify(contactData));

          const {
            totalMandateVotes,
            totalMandateTantiemesChargeGenerale,
            reducedMandateTantiemesChargeGenerale,
          } = this.getVotingLimitRulesInfoForAGroupOfMandates(groupOfMandates);

          const {
            participantHasDummyVideoPresenceStatus,
            participantPresenceType,
          } = this.getPresenceInfoForAGroupOfMandates(groupOfMandates);

          // !!!: modified values (sum)
          contactDataModified = Object.assign(contactDataModified, {
            isParticipant: true,
            presenceType: participantPresenceType,
            hasDummyVideoPresenceStatus: participantHasDummyVideoPresenceStatus,
            totalMandateVotes: totalMandateVotes,
            totalMandateTantiemesChargeGenerale: totalMandateTantiemesChargeGenerale,
            reducedMandateTantiemesChargeGenerale: reducedMandateTantiemesChargeGenerale, // ..
          });

          contactsOptions.push(contactDataModified);
        }
      }

      return contactsOptions;
    },
    getVotingLimitRulesInfoForAGroupOfMandates(groupOfMandates) {
      var totalMandateVotes = groupOfMandates.length;
      var totalMandateTantiemesChargeGenerale = this.getMandatesTantiemesChargeGenerale(
        groupOfMandates,
        true,
        "total"
      );
      var reducedMandateTantiemesChargeGenerale = this.getMandatesTantiemesChargeGenerale(
        groupOfMandates,
        true,
        "reduced"
      );
      return {
        totalMandateVotes,
        totalMandateTantiemesChargeGenerale,
        reducedMandateTantiemesChargeGenerale,
      };
    },
    getPresenceInfoForAGroupOfMandates(groupOfMandates) {
      var participantHasDummyVideoPresenceStatus = groupOfMandates[0].dummy_video_presence_status
        ? true
        : false;

      var participantPresenceStatus = groupOfMandates[0].presence_status;
      var participantPresenceType = "physical";
      if (
        participantPresenceStatus == this.mandatePresenceStatuses.video ||
        participantPresenceStatus == this.mandatePresenceStatuses.pouvoir_by_video
      ) {
        participantPresenceType = "video";
      }
      return { participantHasDummyVideoPresenceStatus, participantPresenceType };
    },

    getBOsNotShowedUpAbsentOpts() {
      var mandatesThatDidNotShowUpAndAbsent = this.getMandatesThatDidNotShowUpAndAbsent();
      return this.getBOsFromBuildingOwnersData(mandatesThatDidNotShowUpAndAbsent);
    },

    /** get BOs that did show up or are represented and absent */
    getBOsShowedUpOrRepresentedAbsentOpts() {
      var mandatesThatDidShowUpButRepresentedAndAbsent = this.getMandatesThatDidShowUpButRepresentedAndAbsent();
      return this.getBOsFromBuildingOwnersData(mandatesThatDidShowUpButRepresentedAndAbsent);
    },

    getBosCsSowedUpOrRepresentedAbsentOpts() {
      var mandatesThatDidShowUpButRepresentedAndAbsent = this.getMandatesThatDidShowUpButRepresentedAndAbsentWithCs();
      return this.getBOsFromBuildingOwnersData(mandatesThatDidShowUpButRepresentedAndAbsent);
    },

    getBOsCsNotShowUpNotIntendToGroupedOpts() {
      var BOsThatDidNotShowUpOptions = this.getBOsNotShowedUpOpts();
      var CsNotShowUpNotIntendToOptions = this.getCsNotShowUpNotIntendToOpts();

      return [
        {
          group: "Copropriétaire",
          items: BOsThatDidNotShowUpOptions,
        },
        {
          group: "Contacts",
          items: CsNotShowUpNotIntendToOptions,
        },
      ];
    },

    /** call restrictions functions */
    getBOsNotShowedUpOrRepresentedAbsentRestrictedOpts(options, mandateRepresentantId) {
      var representedMandates = MandateORM.query()
        .where("meeting_id", this.$route.params.id)
        .where(item => {
          return (
            item.representant_contact_id == mandateRepresentantId ||
            item.representant_owner_id == mandateRepresentantId
          );
        })
        .get();

      var totalCurrentMandateVotes = representedMandates.length;
      // !!!: NOTE: in case participant is owner, substract 1 mandate from sum (ignore his mandate)
      var participantIsOwner = !!representedMandates.find(m => {
        return m.building_owner_id == m.representant_owner_id;
      });
      if (participantIsOwner) totalCurrentMandateVotes--;

      var totalCurrentMandateTantiemesChargeGenerale = this.getMandatesTantiemesChargeGenerale(
        representedMandates,
        true
      );

      return this.addRestrictionsToOptions({
        options,
        totalCurrentMandateVotes,
        totalCurrentMandateTantiemesChargeGenerale,
        isGiveMandateCase: false,
      });
    },
    getBOsCsShowedUpNotAbsentRestrictedOptions(groupedOptions, forCurrentMandate) {
      var totalCurrentMandateVotes = 1;
      var totalCurrentMandateTantiemesChargeGenerale = this.getUsedMandateTantiemesChargeGenerale(
        forCurrentMandate.id
      );
      return this.addRestrictionsToGroupedOptions({
        groupedOptions,
        totalCurrentMandateVotes,
        totalCurrentMandateTantiemesChargeGenerale,
        isGiveMandateCase: true,
      });
    },
    getBOsCsShowedUpNotAbsentAndNotShowedUpRestrictedOpts(
      groupedOptions,
      forCurrentMandate,
      selectedOwnersOrContacts,
      movingMandates
    ) {
      var totalCurrentMandateVotes = 1;
      var totalCurrentMandateTantiemesChargeGenerale = this.getUsedMandateTantiemesChargeGenerale(
        forCurrentMandate.id
      );
      return this.addRestrictionsToGroupedOptions({
        groupedOptions,
        totalCurrentMandateVotes,
        totalCurrentMandateTantiemesChargeGenerale,
        forCurrentMandate,
        selectedOwnersOrContacts,
        movingMandates,
        isGiveMandateCase: true,
      });
    },

    /** !!!: ADD RESTRICTIONS FUNCTIONS ... */
    addRestrictionsToGroupedOptions(info = {}) {
      const {
        groupedOptions,
        totalCurrentMandateVotes,
        totalCurrentMandateTantiemesChargeGenerale,
        forCurrentMandate,
        selectedOwnersOrContacts,
        movingMandates,
        isGiveMandateCase,
      } = info;

      var optionsToBeProcessed = JSON.parse(JSON.stringify(groupedOptions));
      optionsToBeProcessed.forEach(option => {
        option.items.forEach(item => {
          Object.assign(
            item,
            this.addRestrictionsToOptionItem({
              item,
              totalCurrentMandateVotes,
              totalCurrentMandateTantiemesChargeGenerale,
              forCurrentMandate,
              selectedOwnersOrContacts,
              movingMandates,
              isGiveMandateCase,
            })
          );
        });
      });
      return optionsToBeProcessed;
    },
    addRestrictionsToOptions(info = {}) {
      const {
        options,
        totalCurrentMandateVotes,
        totalCurrentMandateTantiemesChargeGenerale,
        isGiveMandateCase,
      } = info;

      var optionsToBeProcessed = JSON.parse(JSON.stringify(options));
      optionsToBeProcessed.forEach(item => {
        Object.assign(
          item,
          this.addRestrictionsToOptionItem({
            item,
            totalCurrentMandateVotes,
            totalCurrentMandateTantiemesChargeGenerale,
            isGiveMandateCase,
          })
        );
      });
      return optionsToBeProcessed;
    },
    addRestrictionsToOptionItem(info = {}) {
      const {
        item,
        totalCurrentMandateVotes,
        totalCurrentMandateTantiemesChargeGenerale,
        forCurrentMandate,
        selectedOwnersOrContacts,
        movingMandates,
        isGiveMandateCase,
      } = info;

      // NOTE: values to compare
      // !!!: they might come from modified options (e.g. sum for represented mandates)
      var totalMandateVotes = item.totalMandateVotes;
      // !!!: NOTE: in case option item is owner and mandates are given to him, substract 1 mandate from his sum (ignore his mandate)
      if (item.type == "owner" && isGiveMandateCase) totalMandateVotes--;

      var totalMandateTantiemesChargeGenerale = item.reducedMandateTantiemesChargeGenerale
        ? item.reducedMandateTantiemesChargeGenerale
        : item.totalMandateTantiemesChargeGenerale;

      if (selectedOwnersOrContacts) {
        ({ totalMandateVotes, totalMandateTantiemesChargeGenerale } = this.recalculateDynamicValues(
          {
            item,
            totalMandateVotes,
            totalMandateTantiemesChargeGenerale,
            forCurrentMandate,
            selectedOwnersOrContacts,
            movingMandates,
          }
        ));
      }

      item["$isDisabled"] = this.checkIfItemShouldBeDisabled(
        totalCurrentMandateVotes,
        totalCurrentMandateTantiemesChargeGenerale,
        totalMandateVotes,
        totalMandateTantiemesChargeGenerale
      );

      return item;
    },
    recalculateDynamicValues(info = {}) {
      const {
        item,
        totalMandateVotes,
        totalMandateTantiemesChargeGenerale,
        forCurrentMandate,
        selectedOwnersOrContacts,
        movingMandates,
      } = info;

      var totalMandateVotesRecalculated = totalMandateVotes;
      var totalMandateTantiemesChargeGeneraleRecalculated = totalMandateTantiemesChargeGenerale;

      // NOTE: when selecting multiple on departing .. modal ask mandates
      for (let [movingMandateId, selectedOwnerOrContact] of Object.entries(
        selectedOwnersOrContacts
      )) {
        if (selectedOwnerOrContact) {
          if (item.identifier == selectedOwnerOrContact.identifier) {
            var movingMandate = movingMandates.find(m => {
              return m.id == movingMandateId;
            });
            // NOTE: currentMovingMandateId --> don't disable option if it is already selected ..
            var currentMovingMandateId = forCurrentMandate ? forCurrentMandate.id : null;
            if (movingMandate)
              if (currentMovingMandateId !== movingMandate.id) {
                totalMandateVotesRecalculated++;
                totalMandateTantiemesChargeGeneraleRecalculated += this.getUsedMandateTantiemesChargeGenerale(
                  movingMandate.id
                ); // from mixins
              }
          }
        }
      }

      return {
        totalMandateVotes: totalMandateVotesRecalculated,
        totalMandateTantiemesChargeGenerale: totalMandateTantiemesChargeGeneraleRecalculated,
      };
    },
    checkIfItemShouldBeDisabled(
      totalCurrentMandateVotes,
      totalCurrentMandateTantiemesChargeGenerale,
      totalMandateVotes,
      totalMandateTantiemesChargeGenerale
    ) {
      if (this.votingLimitRules.votingLimitOperator == this.rulesOptions.rulesOperators.et) {
        return (
          totalMandateVotes + totalCurrentMandateVotes >
            this.votingLimitRules.votesLimitPerMandate ||
          totalMandateTantiemesChargeGenerale + totalCurrentMandateTantiemesChargeGenerale >
            this.votingLimitRules.tantiemesLimitPerMandate
        );
      } else if (this.votingLimitRules.votingLimitOperator == this.rulesOptions.rulesOperators.ou) {
        return (
          totalMandateVotes + totalCurrentMandateVotes >
            this.votingLimitRules.votesLimitPerMandate &&
          totalMandateTantiemesChargeGenerale + totalCurrentMandateTantiemesChargeGenerale >
            this.votingLimitRules.tantiemesLimitPerMandate
        );
      }
      return false;
    },

    /** helper functions to get mandates & contacts to use in main functions */
    getMandatesThatDidNotShowUp() {
      return MandateORM.query()
        .where(item => {
          return item.showed_up != 1;
        })
        .where("meeting_id", this.$route.params.id)
        .get();
    },
    getCsNotShowUpNotIntendTo() {
      var meeting = MeetingORM.query().where("id", this.$route.params.id).first();
      var mandatesRepByCsShowedUpOrIntendTo = MandateORM.query()
        .where(item => {
          return (
            (item.showed_up == 1 ||
              item.presence_status ==
                this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet) &&
            item.representant_contact_id != null
          );
        })
        .where("meeting_id", this.$route.params.id)
        .get();

      var contactsThatShowedUpOrIntendToIds = [];
      mandatesRepByCsShowedUpOrIntendTo.forEach(m => {
        contactsThatShowedUpOrIntendToIds.push(m.representant_contact_id);
      });

      const csNotShowUpNotIntendTo = ContactORM.query()
        .where(item => {
          return (
            !contactsThatShowedUpOrIntendToIds.includes(item.id) &&
            meeting.building_id == item.building_id
          );
        })
        .get();

      return {
        csNotShowUpNotIntendTo: csNotShowUpNotIntendTo,
        contactsThatShowedUpOrIntendToIds: contactsThatShowedUpOrIntendToIds,
      };
    },
    getMandatesThatDidShowUpButRepresented() {
      return MandateORM.query()
        .where(item => {
          return (
            item.showed_up == 1 &&
            item.building_owner_id != item.representant_owner_id &&
            item.representant_contact_id == null
          );
        })
        .where("meeting_id", this.$route.params.id)
        .get();
    },
    getMandatesThatDidShowUpNotRepresented() {
      return MandateORM.query()
        .where(item => {
          return (
            item.showed_up == 1 &&
            item.building_owner_id == item.representant_owner_id &&
            item.representant_contact_id == null
          );
        })
        .where("meeting_id", this.$route.params.id)
        .get();
    },
    getMandatesThatDidShowUpButRepresentedAndAbsent() {
      return MandateORM.query()
        .where(item => {
          return (
            item.showed_up != 1 ||
            (item.showed_up == 1 &&
              item.building_owner_id != item.representant_owner_id &&
              item.representant_contact_id == null &&
              item.presence_status == this.mandatePresenceStatuses.not_present)
          );
        })
        .where("meeting_id", this.$route.params.id)
        .get();
    },
    getMandatesThatDidShowUpButRepresentedAndAbsentWithCs() {
      return MandateORM.query()
        .where(item => {
          return (
            item.showed_up != 1 ||
            (item.showed_up == 1 &&
              item.building_owner_id != item.representant_owner_id &&
              item.presence_status == this.mandatePresenceStatuses.not_present) ||
            item.representant_contact_id != null
          );
        })
        .where("meeting_id", this.$route.params.id)
        .get();
    },
    getMandatesThatDidShowUpAndNotAbsent() {
      return MandateORM.query()
        .where(item => {
          return item.showed_up == 1 && !this.checkIfMandateIsAbsent(item);
        })
        .where("meeting_id", this.$route.params.id)
        .get();
    },
    getMandatesThatDidNotShowUpAndAbsent() {
      return MandateORM.query()
        .where(item => {
          return item.showed_up != 1 && (item.presence_status == null || item.presence_status == 0);
        })
        .where("meeting_id", this.$route.params.id)
        .get();
    },

    getBOsFromBuildingOwnersData(mandates) {
      // OPTIMIZATION: Use Map for O(1) lookups instead of O(n) find() on every iteration
      // With 400 owners, this changes from O(n²) to O(n) complexity
      if (
        !this._boDataCache ||
        this._boDataCacheSize !== this.meetingDetails.BuildingOwnersData.length
      ) {
        this._boDataCache = new Map(
          this.meetingDetails.BuildingOwnersData.map(bo => [bo.mandate_id, bo])
        );
        this._boDataCacheSize = this.meetingDetails.BuildingOwnersData.length;
      }

      var buildingOwnersOptions = [];
      mandates.forEach(mandate => {
        var buildingOwnerData = this._boDataCache.get(mandate.id);
        if (buildingOwnerData) {
          buildingOwnersOptions.push(buildingOwnerData);
        }
      });

      return buildingOwnersOptions;
    },
    getContactsFromContactsData(contacts, contactsThatShowedUpOrIntendToIds) {
      // OPTIMIZATION: Use Map for O(1) lookups instead of O(n) find()
      if (
        !this._contactDataCache ||
        this._contactDataCacheSize !== this.meetingDetails.ContactsData.length
      ) {
        this._contactDataCache = new Map(this.meetingDetails.ContactsData.map(c => [c.id, c]));
        this._contactDataCacheSize = this.meetingDetails.ContactsData.length;
      }

      var contactsOptions = [];

      contacts.forEach(contact => {
        var contactData = this._contactDataCache.get(contact.id);
        if (contactData) {
          contactsOptions.push(contactData);
        }
      });
      // NOTE: If contacts array is empty it can mean that Contacts entity wasn't fetched and we base on the ContactsData from the meeting
      if (contacts.length == 0 && contactsThatShowedUpOrIntendToIds.length > 0) {
        const showedUpIds = new Set(contactsThatShowedUpOrIntendToIds);
        contactsOptions = this.meetingDetails.ContactsData.filter(
          item => !showedUpIds.has(item.id)
        );
      }

      return contactsOptions;
    },
  },
};
